import { Component, Input, ViewEncapsulation } from '@angular/core';

import { Attraction } from '@app/models';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
    selector: 'attraction-carousel',
    templateUrl: './attraction-carousel.component.html',
    styleUrls: ['./attraction-carousel.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AttractionCarouselComponent {
  @Input() attractionsPassedIn: Attraction[];

  // Carousel configuration
  // angular-responsive-carousel2
  carouselHeight: number = 350;
  numberOfImagesToDisplay: number = 3;
  imageAmountToScroll: number = 3;
  overflowImageLimit: number = 3;
  lazyLoadOverflowedImages: boolean = true;


  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    autoHeight: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: [ '<', '>' ],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1240: {
        items: 3
      }
    },
    nav: true
  }

  constructor() { }
}